let PointsBoundary = {
    POINTS_BOUNDARY_SET_INNER: 'POINTS_BOUNDARY_SET_INNER',
    POINTS_BOUNDARY_SET_OUTER: 'POINTS_BOUNDARY_SET_OUTER',
};

export default PointsBoundary;
